module.exports = {
  Typography: {
    DisplayLarge: {
      fontFamily:
        "'ABC Monument Grotesk', 'Noto Sans', ui-sans-serif, system-ui, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'",
      fontWeight: 500,
      lineHeight: "96px",
      fontSize: "64px",
      textDecoration: "none",
    },
    DisplayMedium: {
      fontFamily:
        "'ABC Monument Grotesk', 'Noto Sans', ui-sans-serif, system-ui, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'",
      fontWeight: 500,
      lineHeight: "72px",
      fontSize: "48px",
      textDecoration: "none",
    },
    DisplaySmall: {
      fontFamily:
        "'ABC Monument Grotesk', 'Noto Sans', ui-sans-serif, system-ui, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'",
      fontWeight: 500,
      lineHeight: "54px",
      fontSize: "36px",
      textDecoration: "none",
    },
    HeadingLarge: {
      fontFamily:
        "'ABC Monument Grotesk', 'Noto Sans', ui-sans-serif, system-ui, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'",
      fontWeight: 500,
      lineHeight: "42px",
      fontSize: "28px",
      textDecoration: "none",
    },
    HeadingMedium: {
      fontFamily:
        "'ABC Monument Grotesk', 'Noto Sans', ui-sans-serif, system-ui, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'",
      fontWeight: 500,
      lineHeight: "36px",
      fontSize: "24px",
      textDecoration: "none",
    },
    HeadingSmall: {
      fontFamily:
        "'ABC Monument Grotesk', 'Noto Sans', ui-sans-serif, system-ui, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'",
      fontWeight: 500,
      lineHeight: "30px",
      fontSize: "20px",
      textDecoration: "none",
    },
    HeadingExtraSmall: {
      fontFamily:
        "'ABC Monument Grotesk', 'Noto Sans', ui-sans-serif, system-ui, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'",
      fontWeight: 500,
      lineHeight: "26px",
      fontSize: "18px",
      textDecoration: "none",
    },
    TextLargeBold: {
      fontFamily:
        "'ABC Monument Grotesk', 'Noto Sans', ui-sans-serif, system-ui, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'",
      fontWeight: 500,
      lineHeight: "24px",
      fontSize: "16px",
      textDecoration: "none",
    },
    TextLarge: {
      fontFamily:
        "'ABC Monument Grotesk', 'Noto Sans', ui-sans-serif, system-ui, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'",
      fontWeight: 400,
      lineHeight: "24px",
      fontSize: "16px",
      textDecoration: "none",
    },
    TextLargeLight: {
      fontFamily:
        "'ABC Monument Grotesk', 'Noto Sans', ui-sans-serif, system-ui, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'",
      fontWeight: 300,
      lineHeight: "24px",
      fontSize: "16px",
      textDecoration: "none",
    },
    TextMediumBold: {
      fontFamily:
        "'ABC Monument Grotesk', 'Noto Sans', ui-sans-serif, system-ui, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'",
      fontWeight: 500,
      lineHeight: "20px",
      fontSize: "14px",
      textDecoration: "none",
    },
    TextMedium: {
      fontFamily:
        "'ABC Monument Grotesk', 'Noto Sans', ui-sans-serif, system-ui, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'",
      fontWeight: 400,
      lineHeight: "20px",
      fontSize: "14px",
      textDecoration: "none",
    },
    TextMediumLink: {
      fontFamily:
        "'ABC Monument Grotesk', 'Noto Sans', ui-sans-serif, system-ui, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'",
      fontWeight: 400,
      lineHeight: "20px",
      fontSize: "14px",
      textDecoration: "underline",
    },
    TextMediumLight: {
      fontFamily:
        "'ABC Monument Grotesk', 'Noto Sans', ui-sans-serif, system-ui, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'",
      fontWeight: 300,
      lineHeight: "20px",
      fontSize: "14px",
      textDecoration: "none",
    },
    TextMono: {
      fontFamily:
        "'ABC Monument Grotesk Mono', 'Lucida Console', ui-monospace, SFMono-Regular, Monaco, Consolas, 'Andale Mono', 'Ubunto Mono', monospace",
      fontWeight: 300,
      lineHeight: "20px",
      fontSize: "14px",
      textDecoration: "none",
    },
    TextSmall: {
      fontFamily:
        "'ABC Monument Grotesk', 'Noto Sans', ui-sans-serif, system-ui, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'",
      fontWeight: 400,
      lineHeight: "18px",
      fontSize: "12px",
      textDecoration: "none",
    },
    TextSmallLink: {
      fontFamily:
        "'ABC Monument Grotesk', 'Noto Sans', ui-sans-serif, system-ui, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'",
      fontWeight: 400,
      lineHeight: "18px",
      fontSize: "12px",
      textDecoration: "underline",
    },
    TextExtraSmall: {
      fontFamily:
        "'ABC Monument Grotesk', 'Noto Sans', ui-sans-serif, system-ui, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'",
      fontWeight: 400,
      lineHeight: "14px",
      fontSize: "10px",
      textDecoration: "none",
    },
  },
};
